import { render, staticRenderFns } from "./CourseReviewCommentItem.vue?vue&type=template&id=1327cbb2&"
import script from "./CourseReviewCommentItem.vue?vue&type=script&lang=ts&"
export * from "./CourseReviewCommentItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports